import { apiRequest } from '../config/api';

export interface Conferente {
  id: string;
  nome: string;
  matricula?: string;
  ativo: boolean;
  filiais: string[];
  created_at: string;
  updated_at: string;
}

class ConferentesServiceAPI {
  // Buscar todos os conferentes
  async buscarTodos(ativo?: boolean, filial?: string): Promise<Conferente[]> {
    const params = new URLSearchParams();
    if (ativo !== undefined) params.append('ativo', ativo.toString());
    if (filial) params.append('filial', filial);

    const response = await apiRequest(`/conferentes?${params}`);
    return response.data;
  }

  // Buscar conferente por ID
  async buscarPorId(id: string): Promise<Conferente | null> {
    try {
      const response = await apiRequest(`/conferentes/${id}`);
      return response.data;
    } catch (error) {
      return null;
    }
  }

  // Criar conferente
  async criar(conferente: Omit<Conferente, 'id' | 'created_at' | 'updated_at'>): Promise<Conferente> {
    const response = await apiRequest('/conferentes', {
      method: 'POST',
      body: JSON.stringify(conferente)
    });
    return response.data;
  }

  // Atualizar conferente
  async atualizar(id: string, dados: Partial<Conferente>): Promise<Conferente> {
    const response = await apiRequest(`/conferentes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(dados)
    });
    return response.data;
  }

  // Ativar/Desativar conferente
  async alternarStatus(id: string, ativo: boolean): Promise<Conferente> {
    const response = await apiRequest(`/conferentes/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ ativo })
    });
    return response.data;
  }

  // Excluir conferente
  async excluir(id: string): Promise<void> {
    await apiRequest(`/conferentes/${id}`, {
      method: 'DELETE'
    });
  }

  // Atualizar conferente de uma carga
  async atualizarConferenteCarga(cargaId: string, conferenteId: string | null): Promise<void> {
    await apiRequest(`/conferentes/carga/${cargaId}/conferente`, {
      method: 'PATCH',
      body: JSON.stringify({ conferente_id: conferenteId })
    });
  }

  // Verificar se matrícula já existe
  async matriculaExiste(matricula: string, idExcluir?: string): Promise<boolean> {
    const conferentes = await this.buscarTodos();
    return conferentes.some(c => 
      c.matricula === matricula && c.id !== idExcluir
    );
  }

  // Buscar conferentes disponíveis para uma filial
  async buscarDisponiveisPorFilial(filial: string): Promise<Conferente[]> {
    return this.buscarTodos(true, filial);
  }
}

export default new ConferentesServiceAPI();
